import {Card, CardContent, Typography} from '@mui/material';

export default function AdminQuestionListEmpty() {
  return (
    <Card>
      <CardContent sx={{textAlign: 'center', py: 4}}>
        <Typography variant="h6" sx={{color: '#666', mb: 1}}>
          No questions found
        </Typography>
        <Typography variant="body2" sx={{color: '#999'}}>
          Try adjusting your filters or fetch questions for the selected module.
        </Typography>
      </CardContent>
    </Card>
  );
}
